import React from "react";

// Page header: yellow-underline title + gray subtitle + right-aligned actions.
//
// `subMobile` is the same fact stated for a 375px header, where the desktop
// subtitle either doesn't fit or isn't the one worth keeping ("7 things need
// you · Tue, Aug 11" vs the desktop's fuller line). Both are rendered and CSS
// picks; a JS breakpoint here would make the header flicker on rotate.
// `measured` puts the header on the same centred measure as the page body. Without it
// the header sits hard left while a max-width body centres itself, and on a wide monitor
// the two are a thousand pixels apart — which reads as a broken layout even though each
// half is behaving. Opt-in, because the board genuinely spans the full width.
// `back` is an optional way-out link drawn before the title (see BackLink).
export default function Topbar({ back, title, sub, subMobile, measured = false, children }) {
  return (
    <div className={`crm-topbar${measured ? " crm-topbar--measured" : ""}`}>
      <div className="crm-topbar__left">
        {back}
        <span className="crm-title">{title}</span>
        {sub && (
          <span className={`crm-title-sub${subMobile ? " crm-title-sub--wide" : ""}`}>{sub}</span>
        )}
        {subMobile && <span className="crm-title-sub crm-title-sub--narrow">{subMobile}</span>}
      </div>
      {children && <div className="crm-topbar__right">{children}</div>}
    </div>
  );
}
